import { render } from "./AdminTarife.vue?vue&type=template&id=2875f769&scoped=true"
import script from "./AdminTarife.vue?vue&type=script&lang=js"
export * from "./AdminTarife.vue?vue&type=script&lang=js"

import "./AdminTarife.vue?vue&type=style&index=0&id=2875f769&scoped=true&lang=css"

import exportComponent from "/home/treim/code/casp/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2875f769"]])

export default __exports__